module.exports = __webpack_public_path__ + "img/floatadmin.fw.e505fdb1.png";